module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_contact-e3e615444ba59cf0433dac3033234558.png";